import { render, staticRenderFns } from "./ContentYearGantt.vue?vue&type=template&id=08378cf2&scoped=true&"
import script from "./ContentYearGantt.vue?vue&type=script&lang=js&"
export * from "./ContentYearGantt.vue?vue&type=script&lang=js&"
import style0 from "./ContentYearGantt.vue?vue&type=style&index=0&id=08378cf2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08378cf2",
  null
  
)

export default component.exports